import { useSelector } from "react-redux";
import FooterCustomModal from "../../FooterCustomModal";
import "./FrequentlyAskedQuestionComponent.scss";
import { useState } from "react";
import useLogin from "../../../custom-hooks/useLogin";
import _ from "lodash";

const FrequentlyAskedQuestionComponent = () => {
  const subscribedInfo = useSelector((state) => state.checkout.subscribedData);
  const { isLoggedIn } = useLogin();
  const [showModal, setShowModal] = useState(false);
  return (
    <>
      <section className="faq-section">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="faq-heading">
                {/* Frequently asked questions */}
                Xsel – Payment, Plans and Subscriptions Frequently Asked
                Questions
              </div>
              <div className="faq-sub-head">
                {/* Everything you need to know about the product and billing. */}
                We’re thrilled that you are exploring Xsel for your real estate
                career goals. Here is everything you need to know about Xsel
                subscriptions, payments and plans.
              </div>
            </div>
          </div>
          <div className="row gy-5">
            {false && <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      strokeWidth="8"
                    />
                    <path
                      fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M27.9932 21.1358C25.9938 18.7984 22.6597 18.1696 20.1547 20.31C17.6496 22.4504 17.297 26.029 19.2642 28.5604C20.8998 30.6651 25.8498 35.1041 27.4721 36.5408C27.6536 36.7016 27.7444 36.7819 27.8502 36.8135C27.9426 36.8411 28.0437 36.8411 28.1361 36.8135C28.2419 36.7819 28.3327 36.7016 28.5142 36.5408C30.1365 35.1041 35.0865 30.6651 36.7221 28.5604C38.6893 26.029 38.3797 22.4279 35.8316 20.31C33.2835 18.1922 29.9925 18.7984 27.9932 21.1358Z"
                      stroke="#7F56D9"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="faq-question">
                  {/* Is there a free trial available? */}
                  Does Xsel have a free trial available?
                </div>
                <div className="faq-answer">
                  {/* Yes, you can try us for free for 30 days. Our friendly team
                  will work with you to get you up and running as soon as
                  possible. */}
                  Yes, we have a free trial that is available for 30 days. You
                  can get started as soon as you sign up and there is no upfront
                  payment required to try Xsel free for 30 days. Billing will
                  only begin after the free trial period ends in 30 days in case
                  you wish to continue your Xsel subscription.
                </div>
              </div>
            </div>}
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      strokeWidth="8"
                    />
                    <path
                      d="M36 33H20M20 33L24 29M20 33L24 37M20 23H36M36 23L32 19M36 23L32 27"
                      stroke="#7F56D9"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="faq-question">Can I change my plan later?</div>
                <div className="faq-answer">
                  {/* Of course. Our pricing scales with your company. Chat to our
                  friendly team to find a solution that works for you. */}
                  Yes – our plans are flexible and tailored to your needs. Reach
                  out to our support team at{" "}
                  <a href="mailto:support@xsel.app">support@xsel.app</a> for
                  help with flexible pricing and plans.
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      strokeWidth="8"
                    />
                    <path
                      d="M20.93 20.93L35.07 35.07M38 28C38 33.5228 33.5228 38 28 38C22.4772 38 18 33.5228 18 28C18 22.4772 22.4772 18 28 18C33.5228 18 38 22.4772 38 28Z"
                      stroke="#7F56D9"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="faq-question">
                  What is your cancellation policy?
                </div>
                {!isLoggedIn || _.isEmpty(subscribedInfo?.payload?.data?.subscription_name) || subscribedInfo?.payload?.data?.subscription_name === undefined || subscribedInfo?.payload?.data?.subscription_name === "Starter" ?<div className="faq-answer">
                  You are already in a free subscription, so cancellation does not apply here.
                </div>:<div className="faq-answer">
                  {/* We understand that things change. You can cancel your plan at
                  any time and we’ll refund you the difference already paid. */}
                  We understand that things change. If you would like to cancel
                  or update your payment information, you may do so{" "}
                  <a
                    href="#"
                    onClick={(event) => {
                      event.preventDefault();
                      window.scrollTo(0, 0);
                    }}
                  >
                    here
                  </a>
                  . Remember, you can cancel your plan at any time, and we’ll
                  refund the difference of what you have already paid for the
                  current billing period.
                </div>}
              </div>
            </div>
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      strokeWidth="8"
                    />
                    <path
                      d="M30 18.2695V22.4001C30 22.9601 30 23.2401 30.109 23.4541C30.2049 23.6422 30.3578 23.7952 30.546 23.8911C30.7599 24.0001 31.0399 24.0001 31.6 24.0001H35.7305M30 33H24M32 29H24M36 25.9882V33.2C36 34.8802 36 35.7202 35.673 36.362C35.3854 36.9265 34.9265 37.3854 34.362 37.673C33.7202 38 32.8802 38 31.2 38H24.8C23.1198 38 22.2798 38 21.638 37.673C21.0735 37.3854 20.6146 36.9265 20.327 36.362C20 35.7202 20 34.8802 20 33.2V22.8C20 21.1198 20 20.2798 20.327 19.638C20.6146 19.0735 21.0735 18.6146 21.638 18.327C22.2798 18 23.1198 18 24.8 18H28.0118C28.7455 18 29.1124 18 29.4577 18.0829C29.7638 18.1564 30.0564 18.2776 30.3249 18.4421C30.6276 18.6276 30.887 18.887 31.4059 19.4059L34.5941 22.5941C35.113 23.113 35.3724 23.3724 35.5579 23.6751C35.7224 23.9436 35.8436 24.2362 35.9171 24.5423C36 24.8876 36 25.2545 36 25.9882Z"
                      stroke="#7F56D9"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="faq-question">
                  {/* Can other info be added to an invoice? */}
                  Can additional information be added to an invoice?
                </div>
                <div className="faq-answer">
                  {/* At the moment, the only way to add additional information to
                  invoices is to add the information to the workspace's name. */}
                  While we have limitations on the information we can add to an
                  invoice, please reach out to our billing team{" "}
                  <a href="mailto:support@xsel.app">support@xsel.app</a> and
                  they will help you add necessary information wherever
                  possible.
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      strokeWidth="8"
                    />
                    <path
                      d="M38 26H18M27 35L34.8 35C35.9201 35 36.4802 35 36.908 34.782C37.2843 34.5903 37.5903 34.2843 37.782 33.908C38 33.4802 38 32.9201 38 31.8V24.2C38 23.0799 38 22.5198 37.782 22.092C37.5903 21.7157 37.2843 21.4097 36.908 21.218C36.4802 21 35.9201 21 34.8 21H33M27 35L29 37M27 35L29 33M23 35H21.2C20.0799 35 19.5198 35 19.092 34.782C18.7157 34.5903 18.4097 34.2843 18.218 33.908C18 33.4802 18 32.9201 18 31.8V24.2C18 23.0799 18 22.5198 18.218 22.092C18.4097 21.7157 18.7157 21.4097 19.092 21.218C19.5198 21 20.0799 21 21.2 21H29M29 21L27 23M29 21L27 19"
                      stroke="#7F56D9"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="faq-question">How does billing work?</div>
                <div className="faq-answer">
                  Billing is based on the subscription plan that you choose. The card that you used
                   to purchase your Xsel subscription will be charged monthly if you choose a monthly
                    payment option or annually if you choose an annual payment option. You can cancel your 
                    subscription at any time. You also have the option to purchase courses that are not included 
                    in your current subscription as individual purchases.
                </div>
              </div>
            </div>
            <div className="col-xl-4">
              <div className="faq-box">
                <div className="faq-icon">
                  <svg
                    width="56"
                    height="56"
                    viewBox="0 0 56 56"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      fill="#F4EBFF"
                    />
                    <rect
                      x="4"
                      y="4"
                      width="48"
                      height="48"
                      rx="24"
                      stroke="#F9F5FF"
                      strokeWidth="8"
                    />
                    <path
                      d="M18 23L26.1649 28.7154C26.8261 29.1783 27.1567 29.4097 27.5163 29.4993C27.8339 29.5785 28.1661 29.5785 28.4837 29.4993C28.8433 29.4097 29.1739 29.1783 29.8351 28.7154L38 23M22.8 36H33.2C34.8802 36 35.7202 36 36.362 35.673C36.9265 35.3854 37.3854 34.9265 37.673 34.362C38 33.7202 38 32.8802 38 31.2V24.8C38 23.1198 38 22.2798 37.673 21.638C37.3854 21.0735 36.9265 20.6146 36.362 20.327C35.7202 20 34.8802 20 33.2 20H22.8C21.1198 20 20.2798 20 19.638 20.327C19.0735 20.6146 18.6146 21.0735 18.327 21.638C18 22.2798 18 23.1198 18 24.8V31.2C18 32.8802 18 33.7202 18.327 34.362C18.6146 34.9265 19.0735 35.3854 19.638 35.673C20.2798 36 21.1198 36 22.8 36Z"
                      stroke="#7F56D9"
                      strokeWidth="2"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    />
                  </svg>
                </div>
                <div className="faq-question">
                  How do I change my account email?
                </div>
                <div className="faq-answer">
                 You may please write us at support@xsel.app.
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12">
              <div className="faq-ask-question">
                <div className="question-head-ask">Still have questions?</div>
                <div className="faq-asl-sub-text">
                  Can’t find the answer you’re looking for? Please chat with our
                  team and they will be happy to help.
                </div>
                <div className="ask-btn-faq">
                  <button
                    className="subscriptionbtn"
                    onClick={() => setShowModal(true)}
                  >
                    {/* Get in touch */}Reach out to our team
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <FooterCustomModal
        showModal={showModal}
        setShowModal={setShowModal}
        iframeUrl={"https://www.xsel.app/contact.html"}
      />
    </>
  );
};

export default FrequentlyAskedQuestionComponent;
